/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Article
 */
export interface Article {
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    section_id?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    markdown?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    feature_name?: string;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    description?: string;
    /**
     * 
     * @type {number}
     * @memberof Article
     */
    order_index?: number;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    status?: ArticleStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Article
     */
    version?: string;
    /**
     * 
     * @type {number}
     * @memberof Article
     */
    date?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Article
     */
    tags?: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof Article
     */
    last_reviewed?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof Article
     */
    roles?: Array<ArticleRolesEnum>;
    /**
     * 
     * @type {Array<string>}
     * @memberof Article
     */
    permissions?: Array<ArticlePermissionsEnum>;
}


/**
 * @export
 */
export const ArticleStatusEnum = {
    Draft: 'draft',
    Published: 'published',
    Archived: 'archived'
} as const;
export type ArticleStatusEnum = typeof ArticleStatusEnum[keyof typeof ArticleStatusEnum];

/**
 * @export
 */
export const ArticleRolesEnum = {
    Physician: 'physician',
    Patient: 'patient',
    Admin: 'admin',
    Phlebotomist: 'phlebotomist'
} as const;
export type ArticleRolesEnum = typeof ArticleRolesEnum[keyof typeof ArticleRolesEnum];

/**
 * @export
 */
export const ArticlePermissionsEnum = {
    SuperAdmin: 'super_admin',
    Corporate: 'corporate',
    ShiftManager: 'shift_manager',
    Statistics: 'statistics'
} as const;
export type ArticlePermissionsEnum = typeof ArticlePermissionsEnum[keyof typeof ArticlePermissionsEnum];


/**
 * Check if a given object implements the Article interface.
 */
export function instanceOfArticle(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "title" in value;

    return isInstance;
}

export function ArticleFromJSON(json: any): Article {
    return ArticleFromJSONTyped(json, false);
}

export function ArticleFromJSONTyped(json: any, ignoreDiscriminator: boolean): Article {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'section_id': !exists(json, 'section_id') ? undefined : json['section_id'],
        'title': json['title'],
        'markdown': !exists(json, 'markdown') ? undefined : json['markdown'],
        'feature_name': !exists(json, 'feature_name') ? undefined : json['feature_name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'order_index': !exists(json, 'order_index') ? undefined : json['order_index'],
        'status': !exists(json, 'status') ? undefined : json['status'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'date': !exists(json, 'date') ? undefined : json['date'],
        'tags': !exists(json, 'tags') ? undefined : json['tags'],
        'last_reviewed': !exists(json, 'last_reviewed') ? undefined : json['last_reviewed'],
        'roles': !exists(json, 'roles') ? undefined : json['roles'],
        'permissions': !exists(json, 'permissions') ? undefined : json['permissions'],
    };
}

export function ArticleToJSON(value?: Article | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'section_id': value.section_id,
        'title': value.title,
        'markdown': value.markdown,
        'feature_name': value.feature_name,
        'description': value.description,
        'order_index': value.order_index,
        'status': value.status,
        'version': value.version,
        'date': value.date,
        'tags': value.tags,
        'last_reviewed': value.last_reviewed,
        'roles': value.roles,
        'permissions': value.permissions,
    };
}

